/******************************************************************************************
 *	Anniversary Date Filter
 *******************************************************************************************
 *
 * Takes a date or null and outputs either a placeholder string or a formatted date (va rcDate filter)
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.anniversaryDate', []).filter(
    'anniversaryDate',
    /* @ngInject */
    function(_, $filter, $translate) {
      return function(input, format) {
        if (input) {
          return $filter('rcDate')(input, format);
        }
        return $translate.instant('global.anniversaryDateFilter.pendingFirstOrder');
      };
    }
  );
})();
